import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';

interface IProps {
	children: any;
	tableHeaderItems: any[];
	styleObj?: any;
	paddingStyle?: string;
	planCardId?: number;
	handleClick?: any;
}

export const TableComponent = ({
	children,
	tableHeaderItems,
	styleObj,
	paddingStyle,
	planCardId,
	handleClick,
}: IProps) => {
	const theme = useTheme();

	return (
		<TableContainer
			sx={{
				borderRadius: '8px 8px 0px 0px',
			}}
		>
			<Table sx={{ ...styleObj }} aria-label="simple table">
				<TableHead
					sx={{
						display: planCardId ? (planCardId > 0 ? 'none' : 'contents') : 'auto',
						background: theme.palette.root.lightGreen,
					}}
				>
					<TableRow>
						{tableHeaderItems?.map((item: string, index: number) => {
							return (
								<TableCell key={index} sx={{ padding: paddingStyle || '' }}>
									<Typography
										variant="subtitle"
										sx={{ fontWeight: 700, cursor: handleClick && item ? 'pointer' : 'auto' }}
										onClick={handleClick && item !== '' ? () => handleClick(index) : undefined}
									>
										{item} {'  '}{' '}
										{handleClick && item && (
											<img src="/icons/sorting_arrow.svg" style={{ marginRight: '8px' }} />
										)}
									</Typography>
								</TableCell>
							);
						})}
					</TableRow>
				</TableHead>
				<TableBody>{children}</TableBody>
			</Table>
		</TableContainer>
	);
};
